import React from 'react';
import NumberFormat from "react-number-format";
import { Link } from 'react-router-dom';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';


export default function AdjusterTab({
    loading,
    data,
    perPage = 10,
}) {
  return (
    <div className="table-wrapper pt-3">
        <h2 className='section-title mb-3'>ADJUSTER</h2>
        <Table className="table-list" size="small" >
            <TableHead>
                <TableRow>
                    <TableCell rowSpan='2' className='text-center'>No</TableCell>
                    <TableCell rowSpan='2' className='text-center'>Client</TableCell>
                    <TableCell rowSpan='2' className='text-center'>Type</TableCell>
                    <TableCell colSpan='3' className='text-center'>Case</TableCell>
                    <TableCell colSpan='2' className='text-center'>Pending Payment All</TableCell>
                    <TableCell rowSpan='2' className='text-center'>Comment</TableCell>

                </TableRow>
                <TableRow>
                    <TableCell className='text-center'>Total Case</TableCell>
                    <TableCell className='text-center'>On Progress Case</TableCell>
                    <TableCell className='text-center'>Follow Up Case</TableCell>
                    <TableCell className='text-center' style={{minWidth:200}}>Total OS Invoice <br />(IDR)</TableCell>
                    <TableCell className='text-center'>Total OS Invoice (USD)</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {loading ? (
                    <TableRow>
                        <TableCell colSpan={9} align="center" className="py-5">
                            <CircularProgress color="primary"  />
                        </TableCell>
                    </TableRow>
                ) : (
                    data.length === 0 ? (
                        <TableRow style={{ height: 33 * perPage}}>
                            <TableCell colSpan={9} style={{ textAlign: "center" }}>No OS client</TableCell>
                        </TableRow>
                    ) : (
                        data.map((row, key) => (
                            <TableRow
                                key={row.id}
                                selected={row.selected}>
                                <TableCell>
                                    {key + 1}
                                </TableCell>
                                <TableCell>
                                    <a href={'/os-clients/'+row.id} target='_blank' className='text-uppercase'>{row.name === null ? 'NA' : row.name}</a>
                                </TableCell>
                                <TableCell>{row.type === null ? 'NA' : row.type}</TableCell>
                                <TableCell>{row.total_case === null ? 'NA' : row.total_case}</TableCell>
                                <TableCell>{row.case_onprogress === null ? 'NA' : row.case_onprogress}</TableCell>
                                <TableCell>{row.case_followup === null ? 'NA' : row.case_followup}</TableCell>
                                <TableCell>
                                    Rp <NumberFormat thousandSeparator={true} decimalScale={2} value={row.pending_idr === null ? '-' : row.pending_idr} displayType={'text'} renderText={value => <span>{value}</span>}/>
                                </TableCell>
                                <TableCell>

                                    $ <NumberFormat thousandSeparator={true} decimalScale={2} value={row.pending_usd === null ? '-' : row.pending_usd} displayType={'text'} renderText={value => <span>{value}</span>}/>
                                </TableCell>
                                <TableCell>{row.last_comment === null ? '-' : row.last_comment}
                                    <Link to={'/clients/edit/' + row.id} target='_blank' className='btn-icon mr-2'>
                                        <i className='fas fa-edit'> </i>
                                    </Link></TableCell>

                            </TableRow>
                        ))
                    )
                )}

            </TableBody>
        </Table>
    </div>
  );
}
